import React from "react";
export var QuantitySelector = function (_a) {
    var quantity = _a.quantity, onDecrease = _a.onDecrease, onIncrease = _a.onIncrease;
    return (React.createElement("div", { className: "item-customization-quantity-selector" },
        React.createElement("button", { type: "button", onClick: onDecrease, className: "item-customization-quantity-button" }, "-"),
        React.createElement("span", { className: "item-customization-quantity-value" }, quantity),
        React.createElement("button", { type: "button", onClick: onIncrease, className: "item-customization-quantity-button" }, "+")));
};
